/**
 * What the shell knows that a page may want: the console's identity, this
 * browser's pinned and recent pages, the counts the navigation shows, and a
 * way for a page to name itself.
 *
 * Optional by design — `useShell()` returns null outside the shell (the
 * sign-in screen), and every consumer copes.
 */
import { createContext, useContext } from 'react';

const ShellContext = createContext(null);

export function ShellProvider({ value, children }) {
  return <ShellContext.Provider value={value}>{children}</ShellContext.Provider>;
}

export function useShell() {
  return useContext(ShellContext);
}
